import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function EngagementBarThreeStepSetup() {
    return (
        <OnboardingBody title='Start with a quick 3-step setup' statusText='Engagement bar'>
            <p>
                Before your Engagement bar can go live, Nutshell AI needs a short setup to learn
                from your website and train your chatbot, as well as power your smart nudges.
            </p>
        </OnboardingBody>
    );
}
